import React from "react";
import "./index.scss";
import { documentType} from '../../../../../utils/constants';
import moment from "moment";
import TimezoneClock from "../../../../../components/common/TimeZone";
import { useSelector } from "react-redux";
const Info = ({data}) => {
	const userDetail = useSelector((state) => state?.user?.user);
	console.log('data?.version',data)
	return (
		<>
			<div className="info">
				{/*<div className="info-rw">
					<h2>Description</h2>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit.
					</p>
				</div> */}
				<div className="info-rw">
					<h2>Details</h2>
					<div className="detail-blc">

					    {(data?.user || data?.admin )  && (<div className="row-cell">
							<span>Associated with: </span>
							<label className="d-block">{data?.user ? data?.user?.fname + ' ' + data?.user?.lname :  data?.admin?.fname + ' ' + data?.admin?.lname}</label>
						</div>)}

						{data?.packet_type && (<div className="row-cell">
							<span> Type:</span>
							<label className="d-block">{data?.packet_type?.type}</label>
						</div>)}
						{/*<div className="row-cell">
							<span>Date Recevied: </span>
							<label className="d-block">{data?.type?.name}</label>
						</div>
						<div className="row-cell">
							<span>Expiration date: </span>
							<label className="d-block">{data?.type?.name}</label>
                       </div>*/}

						{data?.location?.name && (<div className="row-cell">
							<span>Workgroup: </span>
							<label className="d-block">{data?.location?.name}</label>
						</div>)}

						{/*<div className="row-cell">
							<span>Patriot Act Created: </span>
							<label className="d-block">No</label>
			            </div> */}
						{data?.type && (<div className="row-cell">
							<span>Label </span>
							<label className="d-block">{data?.type?.name}</label>
							{data?.types && (<div className="row-cell">
							<label className="d-block">{data?.types?.name}</label>
						</div>)}
						</div>)}
						{data?.version ? (<div className="row-cell">
							<span>Version</span>
							<label className="d-block">{data?.version}</label>
						</div>) : null}

						{data?.loan_number && (<div className="row-cell">
							<span> Seller Loan Number</span>
							<label className="d-block">{data?.loan_number}</label>
						</div>)}

						

						{data?.bank_detail && (<div className="row-cell">
							<span> Bank Name</span>
							<label className="d-block">{data?.bank_detail?.name}</label>
						</div>)}
						<div className="row-cell">
							<span>Created on </span>
							<label className="d-block">{
							(data.createdAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={data.createdAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail.timezone} dateTime={data.createdAt} timeFormat={"h:mm a"} /></> : 
							moment(data.createdAt).format(
                                          "MMM DD,YYYY"
                                        ) + ' at ' + moment(data?.createdAt).format(
											"h:mm a"
										  )}</label>
						</div>
						{data.hasOwnProperty('version') && (<div className="row-cell">
						 <span> {data?.reviewLabeled ? 'Labeled on' : 'Updated on'} </span>
							<label className="d-block">{
							(data.updatedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={data.updatedAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail.timezone} dateTime={data.updatedAt} timeFormat={"h:mm a"} /></> :
							 moment(data.updatedAt).format(
                                          "MMM DD,YYYY"
                                        ) + ' at ' + moment(data.updatedAt).format(
											"h:mm a"
										  )}</label>
						</div>)}

						{data?.reviewLabeled  && (<div className="row-cell">
							<span>Labeled: </span>
							<label className="d-block">{data?.reviewLabeledByUser ? data?.reviewLabeledByUser?.fname + ' ' + data?.reviewLabeledByUser?.lname :  data?.reviewLabeledByAdmin?.fname + ' ' + data?.reviewLabeledByAdmin?.lname}</label>
						</div>)}
						{/*<div className="row-cell">
							<span>Created By</span>
							<label className="d-block">John Doe</label>
						</div>
						<div className="row-cell">
							<span>Owner</span>
							<label className="d-block">Company Name</label>
						</div> */}
					</div>
				</div>
			</div>
		</>
	);

}

export default Info;